import React from 'react';
import ProvisionPendingProductInstanceView from '../../views/pending-product-instance/provision';
import { ProductInstanceCollection, CustomerCollection, LocationCollection, ProductVersionsCollection, PendingProductInstanceCollection } from '../../services/collection';
import { withRouter } from 'react-router-dom';

class ProvisionPendingProductInstanceScreen extends React.Component {

  state = {
    editing: null,
    disabled: false
  };

  onSave = async () => {
    if (!this.isValid()) {
      return null;
    }
    const { editing } = this.state;
    const { match: { params: { from } }, history } = this.props;
    await new Promise(resolve => this.setState({
      disabled: true
    }, resolve));
    try {
      await ProductInstanceCollection.actions.save(editing, from);
      // If we can go back, do it, if we can't then go home
      if (history.length >= 1) {
        history.go(-1);
      } else {
        history.push('/');
      }
    } catch(e) {
      console.warn(e);
      alert('Failed to provision product');
      await new Promise(resolve => this.setState({
        disabled: false
      }, resolve));
    }
  };

  onCancel = () => {
    const { history } = this.props;
    if (history.length >= 1) {
      history.go(-1);
    } else {
      history.push('/');
    }
  };

  onChange = (property, defaultValue = {}) => {
    return value => this.setState(({ editing }) => ({
      editing: {
        ...(defaultValue || {}),
        ...(editing || {}),
        [property]: value
      }
    }));
  };

  isValid() {
    const { editing } = this.state;
    if (!editing) {
      return false;
    }
    const {
      systemIdentifier,
      productId,
      productVersion,
      systemStatus,
      parentUuid
    } = editing;
    return !!(
      systemIdentifier &&
      productId &&
      productVersion &&
      systemStatus &&
      parentUuid
    );
  }


  static getDefaultVersions() {
    return {
      'com.rewardsinc:location-manager-app': ['1.0.0'],
      'com.rewardsinc:core-data-app': ['1.0.0'],
      'com.rewardsinc:site-controller-app': ['1.0.0'],
      'com.rewardsinc:site-controller-remote-app': ['1.0.0'],
      'com.rewardsinc:update-service-app': ['1.0.0']
    }
  }

  static getVersions(versions) {
    const defaultVersions = ProvisionPendingProductInstanceScreen.getDefaultVersions();
    if (!(versions && typeof versions === 'object')) {
      return defaultVersions;
    }
    const keys = Object.keys(versions);
    if (!keys.length) {
      return defaultVersions;
    }
    const keyWithVersions = keys.find(key => Array.isArray(versions[key]) && versions[key].length);
    return {
      ...defaultVersions,
      ...(keyWithVersions ? versions : {})
    };
  }

  render() {
    const { onSave, onCancel, onChange } = this;
    const { versions, customers, locations: baseLocations, match: { params: { from } }, list = [], loading } = this.props;
    let { editing, disabled } = this.state;
    if (!editing && from) {
      const found = list
          .find(({ hexObjectId }) => from === hexObjectId);
      editing = found;
      if (editing && editing.systemId) {
        const { systemId, ...rest } = editing;
        editing = {
          // Swap to using systemIdentifier, systemId is used for provisioning, but systemIdentifier for provisioned
          systemIdentifier: systemId,
          ...rest
        }
      }
      disabled = loading || !found;
    }
    const {
      systemIdentifier,
      productId,
      productVersion,
      description,
      jurisdiction,
      systemStatus,
      paidThrough,
      parentUuid
    } = (editing || {});
    const location = parentUuid && baseLocations.find(({ uuid }) => uuid === parentUuid);
    const customer = parentUuid && customers.find(({ uuid }) => uuid === parentUuid || (location && location.parentUuid === uuid));

    // Filter locations list so it is just the selected customer
    // Maybe we remove this and just show everything
    let locations = baseLocations;
    if (customer) {
      locations = baseLocations
        .filter(({ parentUuid }) => parentUuid === customer.uuid);
    }

    return (
      <div style={{ padding: 15 }}>
        <ProvisionPendingProductInstanceView
          systemId={systemIdentifier || ''}
          productId={productId || ''}
          productVersion={productVersion || ''}
          description={description || ''}
          jurisdiction={jurisdiction || ''}
          systemStatus={systemStatus || ''}
          paidThrough={paidThrough || 0}
          customer={customer ? customer.uuid : null}
          location={location ? location.uuid : null}

          onSystemId={onChange('systemIdentifier', editing)}
          onProductId={onChange('productId', editing)}
          onProductVersion={onChange('productVersion', editing)}
          onDescription={onChange('description', editing)}
          onCustomer={onChange('parentUuid', editing)}
          onLocation={onChange('parentUuid', editing)}
          onJurisdiction={onChange('jurisdiction', editing)}
          onSystemStatus={onChange('systemStatus', editing)}
          onPaidThrough={onChange('paidThrough', editing)}

          versions={ProvisionPendingProductInstanceScreen.getVersions(versions)}
          customers={customers}
          locations={locations}
          jurisdictions={[
            {
              key: 'MT',
              name: 'Montanta'
            },
            {
              key: 'IL',
              name: 'Illinois'
            }
          ]}
          systemStatuses={[
            'ACTIVE',
            'INACTIVE',
            'STOLEN'
          ]}

          disabled={disabled}
          onSave={onSave}
          onCancel={onCancel}
          canSave={this.isValid()}
        />
      </div>
    )
  }

}


const mapVersionsProps = ({ loading, list }) => ({ versions: list, versionsLoading: loading });
const mapCustomerProps = ({ loading, list }) => ({ customers: list, customersLoading: loading });
const mapLocationProps = ({ loading, list }) => ({ locations: list, locationsLoading: loading });
const mapPendingProductProps = ({ loading, list }) => ({ list, loading });

const versionsConnect = ProductVersionsCollection.connect(mapVersionsProps);
const customerConnect = CustomerCollection.connect(mapCustomerProps);
const locationConnect = LocationCollection.connect(mapLocationProps);
const pendingProductInstanceConnect = PendingProductInstanceCollection.connect(mapPendingProductProps);

export default versionsConnect(
  customerConnect(
    locationConnect(
      pendingProductInstanceConnect(
        withRouter(ProvisionPendingProductInstanceScreen)
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/app/pending-product-instance/provision.js